export default __webpack_public_path__ + "static/media/scene-03-consulting-find-the-right-path.51df6ba4.png";